import moment from 'moment';
import 'moment/locale/ko';

moment.locale('ko')

/**
 * 상수정의
 */
export const CMM = {
    SERVER_URL_AUTH: 'https://chatbotauth.industrybook.co.kr',
    SERVER_URL_API: 'https://chatbotapi.industrybook.co.kr',
    SERVER_URL: 'https://chatbot.industrybook.co.kr',
    // SERVER_URL_API: 'http://localhost:3000/',

};

/**
 * 확장자 가져오기
 */
export const getExt = (file_nm) => {
    return file_nm.toString().split('.').pop();
}